// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    AdditionalRecipients: 'Destinataires supplémentaires',
    Apply: 'Appliquer',
    Approve: 'Approuver',
    Approver_Approved: 'approuvé',
    Approver_HasNotSeen: 'non lus',
    Approver_NoAction: 'aucune action',
    Approver_NotApproved: 'consultée, approbation en attente',
    Approver_Rejected: 'rejetée',
    ApproversGroupTitle: 'Approbateurs',
    Attachment_Delete: 'Le fichier \'{0}\' a été supprimé',
    BaseNotificationRule: 'Sur la base de la règle de notification',
    BeforePageUnloadMessage: 'Vos modifications seront perdues. Voulez-vous quitter cette page sans enregistrer les modifications ?',
    Cancel: 'Annuler',
    Close: 'Fermer',
    ContactAdministrator: 'Veuillez contacter votre administrateur',
    Delete: 'Supprimer',
    DeleteAttachmentContentTemplate: 'Voulez-vous vraiment supprimer la pièce jointe « {0} » ?',
    DeleteAttachmentTitle: 'Supprimer la pièce jointe',
    Download: 'Télécharger',
    DropHere: 'Déposez les fichiers ici',
    Edit: 'Modifier',
    edit_actions: 'Appuyez sur ctrl + entrée pour <a apply>Appliquer</a> ou sur échap pour <a>Annuler</a>',
    email_only_mention_title: 'Cet utilisateur sera averti uniquement par e-mail',
    Error: 'Erreur',
    FilePlural: '1#{0} Fichier#{0} Fichiers',
    FileUploadError: 'Erreur',
    FileVersion: 'Version ',
    FileVersionShort: 'ver ',
    FreeSpaceTemplate: 'Vous avez utilisé {0} Mo sur {1} Mo.',
    HideFiles: 'Masquer les fichiers',
    mention_title: 'Mentionner quelqu\'un',
    Message_Delete: 'Le message a été supprimé.',
    message_maxLength_description: 'Les messages peuvent contenir jusqu\'à 10 000 caractères.',
    message_maxLength_title: 'Le message est trop long',
    MessageDeleteConfirmation: 'Supprimer ce message ?',
    messageEdited: '(modifié)',
    MessageEditedBy: 'Modifié par ',
    messagePlaceholderText: 'Ajoutez un message, déposez des fichiers ou @mentionnez quelqu\'un',
    MultipleApproversTemplate: '{0} sur {1} {2}',
    NewMessageWatermark: 'Saisissez un message ou déposez des fichiers...',
    NewPost: '1#{0} nouveau message #{0} nouveaux messages',
    No: 'Non',
    NoMatchRecipients: 'Membre introuvable',
    NoPermissionToEditMessage: 'Nous sommes désolés, vous n\'avez pas l\'autorisation de modifier ce message',
    Notification: 'Notification',
    Notify: 'Notifier',
    NotifyLabel: 'Notifier...',
    NotProjectMembers: 'Membres n\'appartenant pas au projet',
    Or: 'ou',
    PluralApproved: '1#approuvé#approuvés',
    PluralRejected: '1#{0} rejeté#{0} rejetés',
    Post: 'Publier',
    PostWatingForApproval: 'Le message est en attente d\'approbation',
    PreviewImages: 'Aperçu des images',
    ProjectMembers: 'Membres du projet',
    Reject: 'Rejeter',
    RequestApprovalLabel: 'Approbation de la requête',
    ShowFiles: 'Afficher les fichiers',
    ShowNext: 'Afficher la précédente',
    SingleApprovedTemplate: 'Approuvé par {0}',
    SingleApprovedTemplate_You: 'Approuvé par vous.',
    SingleApproverTemplate: 'En attente d\'approbation de {0}',
    SingleRejectedTemplate: 'Rejeté par {0}',
    SingleRejectedTemplate_You: 'Rejeté par vous.',
    TabEvents: 'Piste d\'audit',
    TabFiles: 'Fichiers',
    TabMessages: 'Messages',
    Teams: 'Équipes',
    Undo: 'Annuler',
    UploadedBy: ' par ',
    Yes: 'Oui',
    You: 'Vous',
};
